import {Grid} from "@mui/material";
import {CopyUtils} from "../../util/CopyUtils";
import {useTranslation} from "react-i18next";
import TextField from "../../common/form/TextField";
import {PersonTranslKey} from "./PersonTranslKey";
import {PersonFilterDto} from "../../client/person/PersonApiClient";

export interface PersonFilterFormProps {
    filter: PersonFilterDto;
    onChange: (filter: PersonFilterDto) => void;
}

export function PersonFilterForm(props: Readonly<PersonFilterFormProps>) {
    const {filter, onChange} = props;

    const {t} = useTranslation();

    function onPersonFirstnameChange(personFirstname: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.firstNameLike = normalizeString(personFirstname);
        onChange(updatedFilter);
    }

    function onPersonLastnameChange(personLastname: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.lastNameLike = normalizeString(personLastname);
        onChange(updatedFilter);
    }

    function onPersonEmailChange(personEmail: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.emailLike = normalizeString(personEmail);
        onChange(updatedFilter);
    }

    function normalizeString(value: string): string | undefined {
        const normalizedValue = value.trim();
        return (normalizedValue.length > 0) ? normalizedValue : undefined;
    }

    return (
        <Grid container mt={0} spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(PersonTranslKey.PERSON_FIRSTNAME)}
                           value={filter.firstNameLike}
                           onChange={onPersonFirstnameChange} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(PersonTranslKey.PERSON_LASTNAME)}
                           value={filter.lastNameLike}
                           onChange={onPersonLastnameChange} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(PersonTranslKey.PERSON_EMAIL)}
                           value={filter.emailLike}
                           onChange={onPersonEmailChange} />
            </Grid>
        </Grid>
    );
}
